export default "__VITE_ASSET__70b06f40__"